import React from "react";
import { Grid } from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget";
import PageTitle from "../../Components/PageTitle";
import KeywordChecker from "../../Components/KeywordChecker/KeywordChecker";

export default function KeywordCheckerPage() {
  var classes = useStyles();

  return (
    <>
      <PageTitle title="Keyword Checker" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title="Keyword Checker"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
          >
            <KeywordChecker />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
